'use client';

import React from "react";
var __jsx = React.createElement;
import { BREAKPOINTS } from "@lib/constants";
import { useMediaQuery } from "react-responsive";
import MaintenanceMobile from "./views/mobile";
import MaintenanceWeb from "./views/web";
const MaintenanceContent = _ref => {
  let {
    maintenanceImage
  } = _ref;
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  if (isMobile) {
    return __jsx(MaintenanceMobile, {
      maintenanceImage: maintenanceImage
    });
  }
  return __jsx(MaintenanceWeb, {
    maintenanceImage: maintenanceImage
  });
};
export default MaintenanceContent;